export default __webpack_public_path__ + "static/media/Lord Atum-Keket's Cape.328bd348.jpg";